"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var FormContext_1 = tslib_1.__importDefault(require("./FormContext"));
;
/** @deprecated @pinto/react-form is not needed anymore, just use MobX */
var Field = /** @class */ (function (_super) {
    tslib_1.__extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._unmount = lodash_1.default.noop;
        return _this;
    }
    Field.prototype.componentWillUnmount = function () {
        this._unmount();
    };
    Field.prototype.render = function () {
        var _a = this.props, name = _a.name, Klass = _a.component, format = _a.format, parse = _a.parse, validate = _a.validate, props = tslib_1.__rest(_a, ["name", "component", "format", "parse", "validate"]);
        if (!this.context.registerField) {
            throw new Error("<Field name='" + name + "' /> used outside of a <Form />");
        }
        this._unmount = this.context.registerField(this.props.name, this, { parse: parse, format: format, validate: validate });
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getFieldProps(this)));
    };
    Field.contextType = FormContext_1.default;
    Field.propTypes = {
        name: prop_types_1.default.string.isRequired,
        component: prop_types_1.default.func.isRequired,
        format: prop_types_1.default.func.isRequired,
        parse: prop_types_1.default.func.isRequired,
        validate: prop_types_1.default.func,
    };
    Field.defaultProps = {
        format: lodash_1.default.identity,
        parse: lodash_1.default.identity,
    };
    return Field;
}(react_1.default.PureComponent));
exports.Field = Field;
exports.default = Field;
//# sourceMappingURL=Field.js.map